import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Zone } from "../lib/intervals";

export type DisplayCurrency = "EUR" | "RON";

interface DisplayState {
  zone: Zone;
  currency: DisplayCurrency;
  setZone(z: Zone): void;
  setCurrency(c: DisplayCurrency): void;
}

export const useDisplay = create<DisplayState>()(
  persist(
    (set) => ({
      zone: "CET",
      currency: "EUR",
      setZone: (zone) => set({ zone }),
      setCurrency: (currency) => set({ currency }),
    }),
    { name: "chro-display" }
  )
);
